import React from "react";
import { Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section className="relative pt-32 pb-20 sm:pt-40 sm:pb-28 overflow-hidden bg-navy-900">
      {image && (
        <div
          className="absolute inset-0 bg-cover bg-center opacity-35"
          style={{ backgroundImage: `url(${image})` }}
        />
      )}
      <div className="absolute inset-0 hero-scrim" />
      <div className="relative max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <Reveal>
          {eyebrow && <p className="eyebrow text-gold-400 mb-5">{eyebrow}</p>}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-white leading-[1.08] text-shadow-navy">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
};

export default PageHero;
